import MoneyConnectHeader1 from "./MoneyConnectHeader1";
import MoneyConnectHeader2 from "./MoneyConnectHeader2";

export const headerTypeComponent = {
  1: MoneyConnectHeader1,
  2: MoneyConnectHeader2,
};
